/**
 * @typedef {import('./interfaces').BetslipNotification} BetslipNotification
 */

export const TOAST_NOTIFICATION_MESSAGE_STATUS = /** @type {const} */ ({
  SUCCESS: 0,
  INFO: 1,
  WARNING: 2,
  ERROR: 3,
  ACTION_NEEDED: -999,
});

/**
 * Get the status of the placement message
 * @param {BetslipNotification} resp - betslip placement response message 
 */
export const getBetNotificationStatus = (resp) => {
  switch (resp.ResponseCode) {
    case 0:
      return resp.BetSlipStatusTypeID;
    case -1: // ERROR during placement flow on backend
    case 1: // invalid user
    case 41: // no funds
    case 43:
    case 76: // transition to live item
      return resp.ResponseCode;
    default:
      return -999; // action needed
  }
};

/**
 * Get the time in seconds for bet toast depending on status
 * @param {number} status - betslip notification status
 */
const getBetToastSettingTime = (status) => {
  let defaultTime = 60;
  switch (status) {
    case 0:
      return +APP_SETTINGS.betslip_v2.successNotificationTimeout || defaultTime;
    case -1:
    case 1:
    case 41:
      return +APP_SETTINGS.betslip_v2.errorNotificationTimeout || defaultTime;
    case -999:
      return +APP_SETTINGS.betslip_v2.warnNotificationTimeout || defaultTime;
    default:
      return +APP_SETTINGS.betslip_v2.pendingNotificationTimeout || defaultTime;
  }
}

/**
 * Get additional time in seconds for bet toast message
 * @param {number} status - betslip notification status
 */
export const getBetToastAdditionalTime = (status) => {
  return getBetToastSettingTime(status) * 1000;
}

/**
 * Get additional time in seconds for regular toast messages
 */
export const getToastAdditionalTime = () => {
  return ((+APP_SETTINGS.settings.toastMessageDuration) || 10) * 1000;
}